import React from 'react';

import './shimmerEmptyImageTextComponent.css';

const ShimmerEmptyImageTextComponent = ({
  ImageComponent = <></>,
  titleTxt = '',
  subTitleTxt = '',
}) => {
  return (
    <div className="et-v2-empty-img-txt-wrapper">
      <div className="et-v2-empty-img-wrap">
        <ImageComponent />
      </div>
      <div className="et-v2-empty-title-txt">{titleTxt}</div>
      <div className="et-v2-empty-sub-title-txt">{subTitleTxt}</div>
    </div>
  );
};

export default ShimmerEmptyImageTextComponent;
